import { flatten, isEmpty } from 'lodash'

export const CRITICAL_ERROR_MESSAGE =
  'Wystąpił krytyczny błąd, skontaktuj się z dostawcą aplikacji'

export const FORBIDDEN_ERROR_MESSAGE = 'Brak uprawnień'

export function api(
  url: RequestInfo,
  body: object | string = {},
  options: RequestInit = {}
) {
  const isGetRequest = !options.method || options.method === 'GET'

  const hostname = process.env.REACT_APP_HOST || ''
  const proxyUrl = 'http://localhost:3001/api-proxy/'

  const headers = new Headers()
  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Credentials', 'true')

  const pathname =
    process.env.NODE_ENV === 'development' ? `${proxyUrl}/` : `${hostname}/api/`
    // todo: hardcoded url for production

  return fetch(`${pathname}${url}`, {
    headers,
    body: !isGetRequest
      ? body instanceof FormData
        ? body
        : JSON.stringify(body)
      : null,
    redirect: 'follow',
    credentials: 'include',
    ...options,
  })
}

export type NormalizedErrors = string[]

export type ErrorResponse = Record<string, any> & {
  errors?: Record<string, string | string[]>
}

export function normalizeErrors(errors: ErrorResponse['errors'] | string) {
  return typeof errors === 'string' ? [errors] : flatten(Object.values(errors!))
}

export async function apiJSON(...args: Parameters<typeof api>) {
  const response = await api(...args)

  if (response.status === 401) {
    throw normalizeErrors('Błąd autoryzacji')
  }

  if (response.status === 404) {
    throw normalizeErrors(CRITICAL_ERROR_MESSAGE)
  }

  if (response.status === 403) {
    window.location.href = '/client'
    throw normalizeErrors(FORBIDDEN_ERROR_MESSAGE)
  }

  if (response.status === 204) {
    return null
  }

  if (!response.ok) {
    const data: ErrorResponse = await response.json()
    const errors = data?.errors

    if (!isEmpty(errors)) {
      throw normalizeErrors(errors)
    } else {
      throw normalizeErrors(CRITICAL_ERROR_MESSAGE)
    }
  }

  try {
    return await response.json()
  } catch {
    return null
  }
}
